module.exports = __webpack_public_path__ + "static/media/LTO_Promo_Image@3x.cbd02302.png";